import { FormField } from '../../../models/form';
import { InputWrapper } from '../input-wrapper/input-wrapper';
import { CFormInput } from '@coreui/react';

import { parseDateSafely } from './date-picker-functions';
import { useTranslation } from 'react-i18next';

export type DateProp = {
  enabled: boolean;
  date: string;
};

export const DatePicker = (props: {
  field: FormField;
  maxDate?: DateProp;
  minDate?: DateProp;
  onChange: (val: string) => void;
  value: string;
  warning: any;
}) => {
  const { t } = useTranslation();

  const getDisplayValue = () => {
    if (!props.value) return '';

    if (/^\d{4}-\d{2}-\d{2}$/.test(props.value)) {
      const dateObj = parseDateSafely(props.value);
      if (dateObj) {
        return props.value;
      }
    }

    return props.value;
  };

  return (
    <InputWrapper
      component={
        <CFormInput
          type='date'
          placeholder=' '
          data-e2eid={`date_picker_${props.field.id}`}
          floatingLabel={t(`input-${props.field.id}`)}
          id={props.field.id}
          max={props.maxDate && props.maxDate.enabled ? props.maxDate.date : ''}
          min={props.minDate && props.minDate.enabled ? props.minDate.date : ''}
          onChange={event => props.onChange(event.target.value)}
          value={getDisplayValue()}
        />
      }
      warning={props.warning}
      id={props.field.id}
    />
  );
};
